/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prefer-stateless-function */

import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route, Switch } from "react-router-dom";
import AppliedRoute from "./AppliedRoute";
import HomePage from "../homepage/HomePage";
import NewsPage from "../NewsPage";
import NotFoundPage from "../NotFoundPage";
import QuizPage from "../quiz/QuizPage";
import LoginPage from "../LoginPage";
import SignupPage from "../signup/SignupPage";
import ConnectedSignupAccountPage from "../auth/SignupAccountPage";
import ConnectedEmailVerificationPage from "../auth/EmailVerificationPage";
import GalleryPage from "../GalleryPage";
import ConnectedManagementPage from "../manage/ManagementPage";
import LessonReminderUnsubscribe from "../notifications/LessonReminderUnsubscribe";
import ConnectedClientPortal from "../client/ClientPortal";
import PaymentPage from "../PaymentPage";
import TermsPage from "../legal/TermsPage";

class Routes extends React.Component {
  render() {
    const { childProps } = this.props;
    return (
      <div>
        <Switch>
          <AppliedRoute
            path="/"
            component={HomePage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/login"
            component={LoginPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/news"
            component={NewsPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/quiz"
            component={QuizPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/signup"
            component={SignupPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/account/signup"
            component={ConnectedSignupAccountPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/email-verification/confirm"
            component={ConnectedEmailVerificationPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/gallery"
            component={GalleryPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/payment"
            component={PaymentPage}
            exact
            props={childProps}
          />
          <AppliedRoute
            path="/terms"
            component={TermsPage}
            exact
            props={childProps}
          />
          <Route
            path="/regulamin"
            exact
            render={() => <Redirect to="/terms" />}
          />
          <AppliedRoute
            path="/notifications/lesson-reminders/unsubscribe"
            component={LessonReminderUnsubscribe}
            exact
            props={childProps}
          />
          <Route
            path="/client"
            render={props => <ConnectedClientPortal {...props} {...childProps} />}
          />
          <Route path="/support/:schoolId/:reportId" component={SupportEntry} exact />
          <Route path="/manage" component={ConnectedManagementPage} props={childProps} />
          <Route component={NotFoundPage} exact props={childProps} />
        </Switch>
      </div>
    );
  }
}

Routes.propTypes = {
  childProps: PropTypes.object.isRequired,
};

export default Routes;
import SupportEntry from '../support/SupportEntry';
